import { render, staticRenderFns } from "./modelTips.vue?vue&type=template&id=6a217e7c&scoped=true&"
import script from "./modelTips.vue?vue&type=script&lang=js&"
export * from "./modelTips.vue?vue&type=script&lang=js&"
import style0 from "./modelTips.vue?vue&type=style&index=0&id=6a217e7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a217e7c",
  null
  
)

export default component.exports